const setDisplay = (display) => {
    return {
        type: "SET_DISPLAY",
        payload: display
    }
}

const deleteDisplay = () => {
    return {
        type: "DELETE_DISPLAY",
        payload: {
            type:"",
            value:""
        }
    }
}

export default {
    setDisplay,
    deleteDisplay
}